var IconButton               = require("app/ui/IconButton"),
    Scroller                 = require("enyo-ui/Scroller"),
    ScrollerMouseDragSupport = require("app/ui/ScrollerMouseDragSupport"),
    buttons                  = require("app/theme/buttons"),
    frameThrottle            = require("enyo-perf/utils").frameThrottle,
    kind                     = require("enyo/kind");

require("./TabBar.less");

module.exports = kind(/** @lends app.ArtistPage.TabBar.prototype */ {

    /**
     * @private
     */
    name: "app.ArtistPage.TabBar",

    /**
     * @private
     */
    classes: "app-artist-page-tab-bar",

    /**
     * The state of this page.
     *
     * @type  {?Object}
     * @public
     */
    state: null,

    /**
     * @private
     */
    components: [{
        classes:        "app-artist-page-tab-bar__scroller",
        kind:           Scroller,
        mixins:         [ScrollerMouseDragSupport],
        vertical:       false,
        horizontal:     true,
        scrollChaining: false,
        width:          "100%",
        components:     [{
            classes:    "app-artist-page-tab-bar__tabs",
            components: [{
                name:    "contentTab",
                kind:    IconButton,
                classes: "app-artist-page-tab-bar__tab active",
                theme:   buttons["app.ArtistPage.TabBar.tab"]
            }, {
                name:       "agendaTab",
                kind:       IconButton,
                classes:    "app-artist-page-tab-bar__tab disabled",
                theme:      buttons["app.ArtistPage.TabBar.tab"],
                components: [{
                    name:    "agendaTabComingSoon",
                    classes: "app-artist-page-tab-bar__tab__coming-soon"
                }]
            }, {
                name:       "shopTab",
                kind:       IconButton,
                classes:    "app-artist-page-tab-bar__tab disabled",
                theme:      buttons["app.ArtistPage.TabBar.tab"],
                components: [{
                    name:    "shopTabComingSoon",
                    classes: "app-artist-page-tab-bar__tab__coming-soon"
                }]
            }, {
                name:       "aboutTab",
                kind:       IconButton,
                classes:    "app-artist-page-tab-bar__tab disabled",
                theme:      buttons["app.ArtistPage.TabBar.tab"],
                components: [{
                    name:    "aboutTabComingSoon",
                    classes: "app-artist-page-tab-bar__tab__coming-soon"
                }]
            }]
        }]
    }],

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.update = frameThrottle(this.bindSafely(this.update));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.update);
            this.update();
        };
    }),

    /**
     * @protected
     */
    update: function() {
        var $i18nService = this.app.$.i18nService,
            $contentTab  = this.$.contentTab,
            $agendaTab   = this.$.agendaTab,
            $shopTab     = this.$.shopTab,
            $aboutTab    = this.$.aboutTab;

        $contentTab.set("caption", $i18nService.getString("app.ArtistPage.TabBar.contentTab.caption"));
        $contentTab.set("tooltip", $i18nService.getString("app.ArtistPage.TabBar.contentTab.tooltip"));

        $agendaTab.set("caption", $i18nService.getString("app.ArtistPage.TabBar.agendaTab.caption"));
        $agendaTab.set("tooltip", $i18nService.getString("app.ArtistPage.TabBar.agendaTab.tooltip"));

        $shopTab.set("caption", $i18nService.getString("app.ArtistPage.TabBar.shopTab.caption"));
        $shopTab.set("tooltip", $i18nService.getString("app.ArtistPage.TabBar.shopTab.tooltip"));

        $aboutTab.set("caption", $i18nService.getString("app.ArtistPage.TabBar.aboutTab.caption"));
        $aboutTab.set("tooltip", $i18nService.getString("app.ArtistPage.TabBar.aboutTab.tooltip"));

        this.$.agendaTabComingSoon.set("content", $i18nService.getString("app.ArtistPage.TabBar.Tab.comingSoon"));
        this.$.shopTabComingSoon.set("content", $i18nService.getString("app.ArtistPage.TabBar.Tab.comingSoon"));
        this.$.aboutTabComingSoon.set("content", $i18nService.getString("app.ArtistPage.TabBar.Tab.comingSoon"));
    }

});
